(function () {
    function initGallery(root) {
      var gallery = root.querySelector('[data-eg-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-eg-main]');
      if (!main) return;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-eg-thumb]'));
      var optButtons = Array.prototype.slice.call(root.querySelectorAll('[data-eg-opt]'));
      var comboEls = Array.prototype.slice.call(root.querySelectorAll('[data-eg-combo]'));
      var combos = comboEls.map(function (c) {
        return {
          v1: c.getAttribute('data-v1') || '',
          v2: c.getAttribute('data-v2') || '',
          src: c.getAttribute('data-src') || '',
          alt: c.getAttribute('data-alt') || ''
        };
      });
      var selected = { '1': null, '2': null };

      function setMain(src, alt) {
        if (!src) return;
        main.src = src;
        if (alt) main.alt = alt;
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') === src);
        });
      }

      function syncOptButtons() {
        optButtons.forEach(function (b) {
          var ax = b.getAttribute('data-eg-opt');
          b.classList.toggle('is-active', selected[ax] === b.getAttribute('data-eg-val'));
        });
      }

      function findCombo() {
        for (var i = 0; i < combos.length; i++) {
          var c = combos[i];
          if (c.v1 !== (selected['1'] || '')) continue;
          if (selected['2'] != null && selected['2'] !== '' && c.v2 !== selected['2']) continue;
          return c;
        }
        return null;
      }

      function resolveFromSelection() {
        var c = findCombo();
        if (c) setMain(c.src, c.alt);
        syncOptButtons();
      }

      // Seed selected from the pre-active option button on each axis.
      optButtons.forEach(function (b) {
        var ax = b.getAttribute('data-eg-opt');
        if (b.classList.contains('is-active') && selected[ax] == null) {
          selected[ax] = b.getAttribute('data-eg-val');
        }
      });

      function activateThumb(t) {
        setMain(t.getAttribute('data-full'), t.getAttribute('data-alt'));
        var v1 = t.getAttribute('data-v1');
        var v2 = t.getAttribute('data-v2');
        var changed = false;
        if (v1) { selected['1'] = v1; changed = true; }
        if (v2) { selected['2'] = v2; changed = true; }
        if (changed) syncOptButtons();
      }

      optButtons.forEach(function (b) {
        b.addEventListener('click', function () {
          selected[b.getAttribute('data-eg-opt')] = b.getAttribute('data-eg-val');
          resolveFromSelection();
        });
      });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { activateThumb(t); });
      });

      // Swipe left / right through the photos on touch devices.
      var stage = gallery.querySelector('[data-eg-stage]');
      function currentIndex() {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].classList.contains('is-active')) return i;
        }
        return 0;
      }
      function showIndex(i) {
        if (!thumbs.length) return;
        var n = thumbs.length;
        var idx = ((i % n) + n) % n;
        var t = thumbs[idx];
        activateThumb(t);
        t.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
      if (stage) {
        var startX = 0, startY = 0, tracking = false;
        stage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = (e.changedTouches && e.changedTouches[0]) || null;
          if (!t) return;
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            showIndex(currentIndex() + (dx < 0 ? 1 : -1));
          }
        }, { passive: true });
      }

      // Prev / next arrow buttons (shown only when there is more than one photo).
      var prevBtn = gallery.querySelector('[data-eg-prev]');
      var nextBtn = gallery.querySelector('[data-eg-next]');
      if (thumbs.length > 1) {
        if (prevBtn) {
          prevBtn.hidden = false;
          prevBtn.addEventListener('click', function () { showIndex(currentIndex() - 1); });
        }
        if (nextBtn) {
          nextBtn.hidden = false;
          nextBtn.addEventListener('click', function () { showIndex(currentIndex() + 1); });
        }
      }

      // Thumbnail-strip scroll affordance: navy prev/next arrows + edge fades on
      // the wrapper, shown only when the thumb row overflows. The arrows scroll
      // the strip; the thumbnail buttons keep their own selection behaviour.
      initThumbScroll(gallery);
    }

    function initThumbScroll(gallery) {
      var wrap = gallery.querySelector('[data-eg-thumbwrap]');
      if (!wrap) return;
      var strip = wrap.querySelector('[data-eg-thumbs]');
      if (!strip) return;
      var prev = wrap.querySelector('[data-eg-thumb-prev]');
      var next = wrap.querySelector('[data-eg-thumb-next]');
      var TOL = 2;

      function update() {
        var max = strip.scrollWidth - strip.clientWidth;
        if (max <= TOL) {
          wrap.removeAttribute('data-eg-thumb-edge');
          if (prev) prev.hidden = true;
          if (next) next.hidden = true;
          return;
        }
        var x = strip.scrollLeft;
        var atStart = x > TOL;
        var atEnd = x < max - TOL;
        var edges = [];
        if (atStart) edges.push('start');
        if (atEnd) edges.push('end');
        wrap.setAttribute('data-eg-thumb-edge', edges.join(' '));
        if (prev) prev.hidden = !atStart;
        if (next) next.hidden = !atEnd;
      }

      var raf = null;
      function schedule() {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = null; update(); });
      }

      function nudge(dir) {
        var amount = Math.max(120, strip.clientWidth * 0.75);
        strip.scrollBy({ left: dir < 0 ? -amount : amount, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { nudge(-1); });
      if (next) next.addEventListener('click', function () { nudge(1); });

      strip.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(schedule);
        ro.observe(strip);
      }
      Array.prototype.forEach.call(strip.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', schedule, { once: true });
      });
      update();
    }

    function initAll() {
      document.querySelectorAll('.eg-hpdp').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.eg-hpdp');
      if (root) initGallery(root);
    });
  })();
